import { Body } from '@assembly-js/design-system';
import classNames from 'classnames';
import React from 'react';

import { formatNotificationCount } from 'src/utils/NotificationsUtils';

interface NotificationBadgeProps {
  content: number;
  isSidebar?: boolean;
  showZero?: boolean;
  isPreview?: boolean;
  htmlId?: string;
  previewClass?: string;
  backgroundColor: string;
  textColor: string;
}

export const NotificationBadge: React.FC<NotificationBadgeProps> = React.memo(
  ({
    content,
    showZero = false,
    isPreview = false,
    htmlId,
    previewClass = '',
    backgroundColor,
    textColor,
  }) => {
    // Base classes
    const baseClasses = classNames(
      'flex items-center justify-center leading-none',
      isPreview ? 'rounded-[2px] px-1 h-3' : 'rounded px-2 h-[18px]',
      {
        'opacity-0': content < 1 && !showZero,
        [previewClass]: isPreview,
      },
    );

    // Dynamic styles for colors
    const dynamicStyles = {
      backgroundColor,
      color: textColor,
    };

    return (
      <span data-testid={htmlId} className={baseClasses} style={dynamicStyles}>
        {!isPreview ? (
          <Body
            size="xs"
            className={['text-current', 'text-[10px]', 'leading-normal'].join(
              ' ',
            )}
          >
            {formatNotificationCount(content)}
          </Body>
        ) : (
          <span className="text-current" style={{ fontSize: 6 }}>
            {content}
          </span>
        )}
      </span>
    );
  },
);

NotificationBadge.displayName = 'NotificationBadge';
